import { render, staticRenderFns } from "./ListDPPage.vue?vue&type=template&id=7b75f841&"
import script from "./ListDPPage.vue?vue&type=script&lang=js&"
export * from "./ListDPPage.vue?vue&type=script&lang=js&"
import style0 from "./ListDPPage.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports